import $ from "jquery";
import Swiper from 'swiper/bundle';

import 'swiper/css/bundle';

function initHero($bl) {
    const swiper = new Swiper($bl.find(".swiper").get(0), {
        loop: true,
        //rewind: true,
        //autoHeight: true,
        
        speed: 1500,
        autoplay: {
            delay: 4000
        },

        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
    });
}

$(function() {
    $(".bl-hero").each(function() {
        initHero($(this));
    });
});

